/* eslint-disable consistent-return */
import { useState, useRef, useEffect } from 'react';

export const minutesToMillis = (min) => min * 1000 * 60;
export const formatTime = (time, decimals) => (time < 10 && decimals ? `0${time}` : `${time}`);

export const useCountDown = ({ deadline = 600000, decimals = true, isPaused = false, endAction = () => {} }) => {
  const interval = useRef(null);
  const [millis, setMillis] = useState(null);
  const minutes = Math.floor(millis / 1000 / 60) % 60;
  const seconds = Math.floor(millis / 1000) % 60;

  const countDown = () => {
    setMillis((prev) => {
      if (prev === 0) {
        clearInterval(interval.current);
        endAction();
        return prev;
      }
      const timeLeft = prev - 1000;
      return timeLeft;
    });
  };

  useEffect(() => {
    setMillis(deadline);
  }, [deadline]);

  useEffect(() => {
    if (isPaused) {
      if (interval.current) clearInterval(interval.current);
      return;
    }
    interval.current = setInterval(countDown, 1000);
    return () => clearInterval(interval.current);
  }, [isPaused]);

  return { minutes: formatTime(minutes, decimals), seconds: formatTime(seconds, decimals), changeLeftTime: setMillis };
};
